module.exports = require("vtk.js/Sources/Common/DataModel/ImageData");